var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScannerHole = function SvgScannerHole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "50%",
    y: "50%",
    width: 250,
    height: 250,
    rx: 50,
    transform: "translate(-125 -125)",
    fill: "#000"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    style: {
      mask: "url(#mask)"
    }
  }));
};
export default SvgScannerHole;